import { render, staticRenderFns } from "./LinksLayout.vue?vue&type=template&id=068d78be&scoped=true&"
import script from "./LinksLayout.vue?vue&type=script&lang=js&"
export * from "./LinksLayout.vue?vue&type=script&lang=js&"
import style0 from "./LinksLayout.vue?vue&type=style&index=0&id=068d78be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "068d78be",
  null
  
)

export default component.exports